const encode = encodeURIComponent;

export default (requests, axios) => {
    return {
        refreshOddsByOutcomeId: (outcomeId) => {
            return requests.get(`/running/refresh-odds/${outcomeId}`);
        }
    }
};
